import axios from 'axios';
import React, { useRef, useState } from 'react';
import {
  checkLoginLockout,
  recordLoginAttempt,
  setLoginSession,
} from '../utils/sessionAuth';

const apiUrl = process.env.REACT_APP_API_URL || 'https://api.mosuseoul.com';

const Login = () => {
  const formRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const loginProcess = async () => {
    try {
      setIsLoading(true);
      setErrorMessage('');

      const lockoutStatus = checkLoginLockout();
      if (lockoutStatus.locked) {
        setErrorMessage(
          `로그인 시도 횟수 초과. ${lockoutStatus.remainingMinutes}분 후 다시 시도해주세요.`
        );
        setIsLoading(false);
        return;
      }

      const data = {
        id: formRef.current.id.value,
        password: formRef.current.password.value,
      };

      const res = await axios.post(`${apiUrl}/api/admin/login`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 10000,
      });

      if (res?.status === 200) {
        recordLoginAttempt(true);
        setLoginSession();
        window.location.href = '/adm';
      } else {
        const attemptResult = recordLoginAttempt(false);
        if (attemptResult.locked) {
          setErrorMessage(
            `로그인 실패 횟수 초과. ${attemptResult.remainingMinutes}분 후 다시 시도해주세요.`
          );
        } else {
          setErrorMessage(
            `로그인 실패. ${attemptResult.attemptsRemaining || 0}회 남았습니다.`
          );
        }
      }
    } catch (error) {
      const attemptResult = recordLoginAttempt(false);

      if (attemptResult.locked) {
        setErrorMessage(
          `로그인 실패 횟수 초과. ${attemptResult.remainingMinutes}분 후 다시 시도해주세요.`
        );
      } else if (error.code === 'ECONNABORTED') {
        setErrorMessage('요청 시간 초과. 다시 시도해주세요.');
      } else if (error.response?.status === 401) {
        setErrorMessage(
          `아이디 또는 비밀번호가 올바르지 않습니다. (${attemptResult.attemptsRemaining || 0}회 남음)`
        );
      } else {
        setErrorMessage('로그인 중 오류가 발생했습니다.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const login = async (e) => {
    e.preventDefault();
    await loginProcess();
  };

  return (
    <>
      <section className="resume-section login" id="admin-login">
        <div className="resume-section-content login">
          <h4>MOSU Admin Login</h4>

          {errorMessage && (
            <div
              style={{
                color: '#ff4444',
                marginBottom: '1rem',
                padding: '0.5rem',
                backgroundColor: '#fff3f3',
                borderRadius: '4px',
              }}
            >
              {errorMessage}
            </div>
          )}

          <form ref={formRef} onSubmit={login}>
            <input
              type="text"
              name="id"
              placeholder="id"
              required
              disabled={isLoading}
              autoComplete="username"
            />
            <input
              type="password"
              name="password"
              placeholder="password"
              required
              disabled={isLoading}
              autoComplete="current-password"
            />
            <button
              type="submit"
              className="btn-login"
              disabled={isLoading}
              style={{ opacity: isLoading ? 0.6 : 1 }}
            >
              {isLoading ? 'Loading...' : 'Login'}
            </button>
          </form>
        </div>
      </section>
    </>
  );
};

export default Login;
